import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import EmptyStateIllustration from '@/components/EmptyStateIllustration'
import { Center } from '@/components/ui/center'
import { Spinner } from '@/components/ui/spinner'
import useDefaultToast from '@/components/useDefaultToast'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import TradeOrder from '@/modules/trade/TradeOrder'
import { fetchTradeOrderThunk, selectCanAccessTrade } from '@/redux/slices/tradeSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { isRejected } from '@reduxjs/toolkit'
import { Stack, useLocalSearchParams } from 'expo-router'
import { useCallback, useEffect, useState } from 'react'

export default function TradeOrderPage() {
  const dispatch = useAppDispatch()
  const { id } = useLocalSearchParams<{ id: string }>()
  const headerLeftItems = useWebBackButton('/trade')

  const canAccessTrade = useAppSelector(selectCanAccessTrade)
  const currentUserLoaded = useAppSelector(state => state.currentUser.loaded)
  const detail = useAppSelector(state => state.trade.orderDetails[id])
  const detailState = useAppSelector(state => state.trade.orderDetailStates[id])

  const toast = useDefaultToast()
  const [refreshing, setRefreshing] = useState(false)

  useEffect(() => {
    if (canAccessTrade) dispatch(fetchTradeOrderThunk(id))
  }, [dispatch, id, canAccessTrade])

  const handleRefresh = useCallback(async () => {
    setRefreshing(true)
    const result = await dispatch(fetchTradeOrderThunk(id))
    setRefreshing(false)
    if (isRejected(result)) toast.show((result.payload as string) || '刷新失败')
  }, [dispatch, id, toast])

  const header = <Stack.Screen options={{ ...buildScreenHeaderItems({ left: headerLeftItems }) }} />

  if (currentUserLoaded && !canAccessTrade) {
    return (
      <>
        {header}
        <Center className="flex-1">
          <EmptyStateIllustration message="你没有查看交易的权限" />
        </Center>
      </>
    )
  }

  if (!detail) {
    return (
      <>
        {header}
        <Center className="flex-1">
          {detailState?.error ? <EmptyStateIllustration message={detailState.error} /> : <Spinner />}
        </Center>
      </>
    )
  }

  return (
    <>
      {header}
      <TradeOrder order={detail.order} buyer={detail.buyer} refreshing={refreshing} onRefresh={handleRefresh} />
    </>
  )
}
